import { Button, Dialog, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

function ConfirmModal({ open, handleClose, handleSubmit, title, children }) {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "1100px",
          },
        },
      }}
      style={{ marginTop: 70 }}
    >
      <DialogTitle
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          margin: 10,
        }}
      >
        <p style={{ margin: 10, fontSize: "26px" }}>{title}</p>
        <p
          style={{
            position: "absolute",
            right: 20,
          }}
        >
          <CloseIcon
            onClick={handleClose}
            style={{ cursor: "pointer", fontSize: 28 }}
          />
        </p>
      </DialogTitle>
      {children}
      <div style={{ textAlign: "center" }}>
        <Button
          variant="contained"
          onClick={handleClose}
          style={{ margin: 20 }}
          size="large"
          color="error"
        >
          Anulează
        </Button>
        <Button
          variant="contained"
          type="submit"
          style={{ margin: 20 }}
          size="large"
          onClick={handleSubmit}
        >
          Salvează
        </Button>
      </div>
    </Dialog>
  );
}

export default ConfirmModal;
ConfirmModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  children: PropTypes.any,
};
